// frontend/src/components/BottomNavBar.tsx
// BottomNavBar — iOS HIG tab bar con íconos Lucide y pill activo gold.

import { LayoutGrid, ClipboardList, UserCog, BarChart2, type LucideIcon } from 'lucide-react';
import { m } from 'motion/react';
import { cn } from '@/lib/utils';
import { SPRING } from '@/lib/motion';

export type NavTab = 'dashboard' | 'presentismo' | 'gestion' | 'reportes';

interface BottomNavBarProps {
  activeTab: NavTab;
  onTabChange: (tab: NavTab) => void;
}

const TABS: { id: NavTab; Icon: LucideIcon; label: string }[] = [
  { id: 'dashboard',    Icon: LayoutGrid,    label: 'Índice' },
  { id: 'presentismo',  Icon: ClipboardList, label: 'Presentismo' },
  { id: 'gestion',      Icon: UserCog,       label: 'Gestión' },
  { id: 'reportes',     Icon: BarChart2,     label: 'Reportes' },
];

export function BottomNavBar({ activeTab, onTabChange }: BottomNavBarProps) {
  return (
    <nav
      className="fixed bottom-0 left-0 w-full z-[1000] flex flex-col"
      style={{
        backgroundColor: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(20px) saturate(1.4)',
        WebkitBackdropFilter: 'blur(20px) saturate(1.4)',
        borderTop: '1px solid rgba(60,60,67,0.13)',
        boxShadow: '0 -1px 0 rgba(60,60,67,0.08)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <div
        className="flex justify-around items-center w-full"
        style={{ minHeight: 64, height: 64, flexShrink: 0 }}
      >
        {TABS.map(({ id, Icon, label }) => {
          const isActive = activeTab === id;
          return (
            <button
              key={id}
              id={`nav-${id}`}
              onClick={() => onTabChange(id)}
              className={cn(
                'relative flex flex-col items-center justify-center gap-0.5 px-3 active:scale-90 transition-transform duration-150',
                'min-w-[60px] h-12 rounded-[14px]',
              )}
              style={{
                color: isActive ? '#745c00' : '#8E8E93',
                flexShrink: 0,
              }}
              aria-label={label}
              aria-selected={isActive}
            >
              {/* Pastilla dorada compartida: se desliza hasta la tab activa */}
              {isActive && (
                <m.span
                  layoutId="nav-pill"
                  className="absolute inset-0 rounded-[14px]"
                  style={{ backgroundColor: '#fed65b' }}
                  transition={SPRING}
                />
              )}
              <Icon
                size={22}
                strokeWidth={isActive ? 2.2 : 1.8}
                className="relative"
              />
              <span
                className="relative text-[10px] font-semibold uppercase tracking-tighter leading-none"
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
